<!--采购订单详情页-->
<template>
  <div class="platform-order-detail">
    <Breadcrumb routeName="OrderList" toName="订单详情" goPathName="订单列表"></Breadcrumb>

    <a-spin :spinning="loading">
      <a-card :bordered="false" class="order-summary-card">
        <a-row type="flex" justify="space-between" align="top" class="summary-header">
          <a-col :span="14">
            <div class="summary-title">
              <span class="summary-icon"><a-icon type="shopping"/></span>
              <span>平台订单号：{{ display(orderDetail.platformOrderNo || platformOrderNo) }}</span>
            </div>
          </a-col>
          <a-col :span="10" class="summary-actions">
            <a-button>备注</a-button>
            <a-dropdown>
              <a-button>...</a-button>
              <!--              <a-menu slot="overlay">-->
              <!--                <a-menu-item key="copy">复制订单号</a-menu-item>-->
              <!--              </a-menu>-->
            </a-dropdown>
            <a-button v-if="showCancelButton" type="primary">取消订单</a-button>
          </a-col>
        </a-row>

        <a-row :gutter="24" class="summary-content">
          <a-col :span="7">
            <div class="summary-line"><span>创建时间：</span>{{ display(orderDetail.createTime) }}</div>
            <div class="summary-line"><span>支付时间：</span>{{ display(orderDetail.payTime) }}</div>
            <div class="summary-line"><span>支付方式：</span>{{ display(orderDetail.payMethod) }}</div>
          </a-col>
          <a-col :span="10">
            <div class="summary-line"><span>商品信息：</span>{{ display(goodsInfo) }}</div>
            <div class="summary-line">
              <span>关联蜗友订单号：</span>
              <a v-if="relatedOrderNo">{{ relatedOrderNo }}</a>
              <span v-else>--</span>
            </div>
            <div class="summary-line"><span>备注：</span>{{ display(orderDetail.remark) }}</div>
          </a-col>
          <a-col :span="7">
            <a-row class="status-list">
              <a-col :span="12">
                <div class="status-label">状态</div>
                <div class="status-value">{{ display(orderStatusText) }}</div>
              </a-col>
              <a-col :span="12">
                <div class="status-label">订单金额</div>
                <div class="amount-value">{{ formatMoney(orderAmount) }}</div>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-card>

      <a-card :bordered="false" title="订单信息" class="detail-card">
        <detail-list :col="3" size="small">
          <detail-list-item term="联系人姓名">{{ display(orderBasic.orderContact) }}</detail-list-item>
          <detail-list-item term="联系电话">{{ display(orderBasic.orderMobile) }}</detail-list-item>
        </detail-list>

        <div class="block-title">商品信息</div>
        <detail-list :col="3" size="small">
          <detail-list-item term="商品标题">{{ display(orderBasic.orderProName) }}</detail-list-item>
          <detail-list-item term="套餐/票型/价格计划名称">{{ display(orderBasic.orderOptionName) }}</detail-list-item>
          <detail-list-item term="商品类目">{{ display(orderBasic.orderProTypeStr) }}</detail-list-item>
          <detail-list-item term="入住日期">{{ display(orderBasic.orderCheckInDate) }}</detail-list-item>
          <detail-list-item term="离店日期">{{ display(orderBasic.orderDepartureDate) }}</detail-list-item>
        </detail-list>

        <div class="block-title">订单价格</div>
        <div class="order-price-row">
          <div><span class="price-label">单价：</span>{{ display(orderBasic.priceDetail) }}</div>
          <div><span class="price-label">数量：</span>{{ display(orderBasic.orderPayNum) }}</div>
          <div><span class="price-label">订单金额：</span>{{ formatMoney(orderAmount) }}</div>
        </div>
      </a-card>

      <a-card :bordered="false" title="分销商备注" class="detail-card remark-card">
        <a-table
          :columns="remarkColumns"
          :dataSource="distributorRemarkList"
          :pagination="false"
          :rowKey="getRemarkRowKey"
          :locale="{ emptyText: '暂无备注' }"
        >
          <template slot="operator" slot-scope="text, record">
            {{ display(text || record.operatorName || record.operationName) }}
          </template>
          <template slot="remarkContent" slot-scope="text, record">
            {{ display(text || record.content || record.remark) }}
          </template>
          <template slot="operateTime" slot-scope="text, record">
            {{ display(text || record.createTime || record.operationTime) }}
          </template>
        </a-table>
      </a-card>
    </a-spin>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'

export default {
  name: 'OrderDetails',
  components: { Breadcrumb },
  data() {
    return {
      loading: false,
      platformOrderNo: this.$route.query.platformOrderNo,
      orderDetail: {},
      orderBasic: {},
      distributorRemarkList: [],
      remarkColumns: [
        { title: '操作人', dataIndex: 'operator', width: 140, scopedSlots: { customRender: 'operator' } },
        { title: '备注内容', dataIndex: 'remarkContent', scopedSlots: { customRender: 'remarkContent' } },
        { title: '操作时间', dataIndex: 'operateTime', width: 220, scopedSlots: { customRender: 'operateTime' } }
      ]
    }
  },
  computed: {
    goodsInfo() {
      return this.orderDetail.goodsInfo || this.orderBasic.orderProName
    },
    relatedOrderNo() {
      return this.orderDetail.relatedOrderNo || this.orderDetail.orderNo
    },
    orderAmount() {
      return this.orderDetail.orderAmount || this.orderDetail.amount || this.orderBasic.orderAmt
    },
    orderStatusText() {
      return this.orderDetail.orderStatusStr || this.orderBasic.orderStateStr || this.orderBasic.orderStatusStr
    },
    showCancelButton() {
      const flag = this.getActionFlag('cancelOrderFlag')
      if (flag !== undefined) return flag
      return ['待支付', '待确认'].indexOf(this.orderStatusText) > -1
    }
  },
  watch: {
    '$route.query.platformOrderNo': {
      immediate: true,
      handler(platformOrderNo) {
        if (!platformOrderNo) return
        this.platformOrderNo = platformOrderNo
        this.getOrderDetail()
      }
    }
  },
  methods: {
    getOrderDetail() {
      this.loading = true
      this.getHttpServices().getOrderService().post('/platform/v3/orderManage/orderDetail', {
        platformOrderNo: this.platformOrderNo
      }).then(res => {
        this.orderDetail = res || {}
        this.orderBasic = this.orderDetail.orderBasic || {}
        this.distributorRemarkList = this.orderDetail.distributorRemarkList || this.orderDetail.remarkList || []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => {
          this.loading = false
        })
    },
    getActionFlag(key) {
      const sourceList = [this.orderDetail, this.orderBasic]
      for (let i = 0; i < sourceList.length; i++) {
        const value = sourceList[i] && sourceList[i][key]
        if (value === undefined || value === null || value === '') continue
        if (value === false || value === 0 || value === '0' || value === 'false') return false
        return true
      }
      return undefined
    },
    getRemarkRowKey(record, index) {
      return record.id || record.remarkId || record.operateTime || index
    },
    display(value) {
      return value === undefined || value === null || value === '' ? '--' : value
    },
    formatMoney(value) {
      if (value === undefined || value === null || value === '') return '--'
      const money = Number(value)
      return isNaN(money) ? value : '￥ ' + money.toFixed(2)
    }
  }
}
</script>

<style scoped lang="less">
.platform-order-detail {
  .order-summary-card,
  .detail-card {
    margin-bottom: 16px;
  }

  /deep/ .order-summary-card .ant-card-body {
    padding: 20px 32px 24px;
  }

  .summary-title {
    display: flex;
    align-items: center;
    height: 32px;
    font-size: 20px;
    font-weight: 600;
    color: #222;
  }

  .summary-icon {
    width: 24px;
    height: 24px;
    margin-right: 12px;
    line-height: 24px;
    text-align: center;
    color: #fff;
    background: #1890ff;
    border-radius: 50%;
  }

  .summary-actions {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;

    .ant-btn {
      margin-left: 8px;
    }
  }

  .summary-content {
    margin-top: 18px;
  }

  .summary-line {
    min-height: 28px;
    line-height: 28px;
    color: rgba(0, 0, 0, .65);

    span {
      color: rgba(0, 0, 0, .85);
    }
  }

  .status-list {
    text-align: right;
  }

  .status-label {
    line-height: 22px;
    color: rgba(0, 0, 0, .45);
  }

  .status-value,
  .amount-value {
    margin-top: 4px;
    font-size: 20px;
    line-height: 28px;
    color: rgba(0, 0, 0, .85);
  }

  .block-title {
    margin: 18px 0 14px;
    font-weight: 600;
    color: rgba(0, 0, 0, .85);
  }

  .order-price-row {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    column-gap: 32px;
    line-height: 32px;
    color: rgba(0, 0, 0, .85);
  }

  .price-label {
    margin-right: 8px;
    font-weight: 500;
  }

  /deep/ .remark-card .ant-table-thead > tr > th {
    font-weight: 600;
    background: #fafafa;
  }
}
</style>